var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"black","color":"white","display":"flex","justify-content":"center","align-items":"center"}},[_c('div',[_vm._v("Error: "+_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }